import { japaneseLanguageExperience } from '@/api/common/master-lists'

const data = {
  items: sessionStorage.getItem('japaneseLanguageExperiences')
    ? JSON.parse(sessionStorage.getItem('japaneseLanguageExperiences'))
    : [],
  loading: false
}

export default {
  namespaced: true,

  state () {
    return {
      ...data
    }
  },
  mutations: {
    /**
     * Set the status.
     *
     * @param {*} state
     * @param {*} items
     */
    SET_LOADING (state, loading) {
      state.loading = loading
    },

    /**
     * Reset the state to default.
     *
     * @param {*} state
     */
    RESET (state) {
      for (const key in state) {
        state[key] = data[key]
      }
    },

    /**
     * Set the items.
     *
     * @param {*} state
     * @param {*} items
     */
    SET_ITEMS (state, items) {
      state.items = items
    }
  },
  actions: {
    /**
     * Get all JapaneseLanguageExperience records.
     *
     * @param {*}
     */
    all ({ commit, dispatch, state }) {
      if (state.items.length) return

      commit('SET_LOADING', true)

      return japaneseLanguageExperience.index()
        .then(({ data }) => {
          commit('SET_ITEMS', data)

          sessionStorage.setItem('japaneseLanguageExperiences', JSON.stringify(data))
        })
        .catch(({ response }) => dispatch('httpException/handle', response, { root: true }))
        .finally(() => commit('SET_LOADING', false))
    }
  }
}
